<template>
  <div class="d-flex fill-width fill-height">
    <div v-if="hasFullTextPdf" class="fill-width fill-height">
      <expandable-content
        class="fill-width"
        :expanded="expanded"
        :height="height"
      >
        <full-text-url-provider
          v-slot="{ url }"
          class="pb-4"
          :reference-id="reference.id"
        >
          <pdf-document v-if="url" :src="url" />
          <div
            v-else
            class="d-flex justify-center align-center fill-width fill-height"
          >
            <v-progress-circular indeterminate color="primary" />
          </div>
        </full-text-url-provider>
      </expandable-content>
      <a class="cursor-pointer" @click="expanded = !expanded">
        {{ expanded ? 'Hide full text PDF' : 'Show full text PDF' }}
      </a>
    </div>
    <upload-full-text-pdf-controller
      v-else
      class="align-center fill-height"
      :reference="reference"
      dense
    />
  </div>
</template>

<script>
import FullTextUrlProvider from '@/components/FullTextReviewPage/FullTextUrlProvider';
import UploadFullTextPdfController from '@/components/UploadFullTextPdfController/UploadFullTextPdfController';
import PdfDocument from '@/components/Common/PdfDocument';
import ExpandableContent from '@/components/Common/ExpandableContent';
import { Reference } from '@/models';

export default {
  name: 'ExpandableFullTextPanel',
  components: {
    FullTextUrlProvider,
    PdfDocument,
    UploadFullTextPdfController,
    ExpandableContent,
  },
  props: {
    reference: {
      type: Reference,
      required: true,
    },
    height: {
      type: Number,
      default: 600,
    },
  },
  data: () => ({
    expanded: false,
  }),
  computed: {
    hasUrl() {
      return !!this.url;
    },
    hasFullTextPdf() {
      return !!this.reference.fullTextPdfUri;
    },
  },
};
</script>

<style lang="scss" scoped>
.fill-width {
  width: 100%;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
